"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Interceptor = void 0;
const react_1 = __importStar(require("react"));
const sentryHandler_1 = require("./sentryHandler");
const isProduction = process.env.NODE_ENV === 'production';
class Interceptor extends react_1.Component {
    constructor() {
        super(...arguments);
        this.state = {
            error: null,
        };
    }
    componentDidCatch(error, errorInfo) {
        const { componentName } = this.props;
        if (isProduction) {
            sentryHandler_1.sentryHandler(error, { extra: { error, errorInfo, componentName }, tag: `${componentName}-interceptor` });
            this.setState({
                error: error,
            });
        }
    }
    render() {
        if (this.state.error) {
            return (react_1.default.createElement("div", { style: { display: 'flex', justifyContent: 'center', alignItems: 'center', flex: '1 1 100%' } },
                react_1.default.createElement("h1", null, "\u0423\u043F\u0441, \u0443 \u043D\u0430\u0441 \u0447\u0442\u043E-\u0442\u043E \u0441\u043B\u043E\u043C\u0430\u043B\u043E\u0441\u044C... =(")));
        }
        return this.props.children;
    }
}
exports.Interceptor = Interceptor;
